import { BusinessProVisitor } from '@fiverr-private/header';

export default BusinessProVisitor;
